var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const CardActionStyle = styled.div `
  position: relative;
  margin-top: 2rem;
  display: flex;
  width: 100%;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  & button {
    margin-left: 1rem;
  }
`;
const CardAction = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return _jsx(CardActionStyle, Object.assign({}, props, { children: children }));
};
export default CardAction;
